const Globals = require("./globals");

const canvas = new fabric.Canvas("board", {
  // backgroundColor: "#f7f7f7",
  selectionColor: "#bbbbff60",
  selectionDashArray: [5, 5],
  selectionLineWidth: 4,
  width: window.innerWidth,
  height: window.innerHeight,
  fireRightClick: true,
  fireMiddleClick: true,
  // topContextMenu: true
  // ...
});

window.addEventListener("resize", () => {
  canvas.setWidth(window.innerWidth);
  canvas.setHeight(window.innerHeight);
});

Globals.canvas = canvas;
